import apiClient from "./config";
import { ECOMMERCE_ENDPOINTS } from "./endpoints";

// Invoice data comes from orders - map orders to invoice format
export const getInvoices = () => apiClient.get(ECOMMERCE_ENDPOINTS.GET_ORDERS).then(r => {
  const orders = r?.data || r || [];
  const mapped = Array.isArray(orders) ? orders.map(o => {
    const addr = typeof o.shipping_address === 'string' ? JSON.parse(o.shipping_address || '{}') : (o.shipping_address || {});
    return {
      _id: o.order_number || o.id,
      invoiceId: '#' + (o.order_number || o.id),
      name: addr.fullName || o.email,
      email: o.email,
      amount: '£' + (Number(o.total) || 0).toFixed(2),
      date: o.created_at,
      status: o.payment_status || o.order_status || 'Pending',
      orderData: o
    };
  }) : [];
  return { data: mapped, status: 'success' };
});
export const addNewInvoice = (invoice) => apiClient.create(ECOMMERCE_ENDPOINTS.ADD_NEW_ORDER, invoice);
export const updateInvoice = (invoice) => apiClient.update(ECOMMERCE_ENDPOINTS.UPDATE_ORDER + '/' + (invoice._id || invoice.order_number || invoice.invoiceId?.replace('#', '')), invoice);
export const deleteInvoice = (id) => apiClient.delete(ECOMMERCE_ENDPOINTS.DELETE_ORDER + '/' + (typeof id === 'string' ? id.replace('#', '') : id));

